import { useLocation } from 'react-router-dom';
import Navbar from './Navbar';

function HowItWorks(){

    const isShowConsole = process.env.NODE_ENV === 'development';

    const location = useLocation();
    isShowConsole && console.log("Current Path:", location.pathname); 

    return(
        <div id='how-it-works' className='howItWorksContainer'>
            <div className='howItWorksWrapper'>
                <div className='contentDiv'>
                    <div className='containerDiv'>
                        <div className='title'>
                            <div className='main'>How It Works</div>
                            <h2 className='sub'>(How to Copy Text from PDF or Image)</h2>
                        </div>
                        <div className='content'>
                            <ul>
                                <li><span>Choose File</span> to upload the file / <span>Open Camera</span> to capture a photo</li>
                                <li>Uploaded PDF or image shows up in the left section </li>
                                <li>Click <span>Extract Text</span> to start text extraction</li> 
                                <li>Extraction starts processing</li> 
                                <li>Extracted text shows up in the right section</li> 
                                <li>Click <span>Copy Text</span> to copy the extracted text to clipboard</li> 
                            </ul>
                            <div className='demoGif'>
                                <img src={'/HowItWorksDemo.gif'} alt='GIF showing how to use the OCR tool to extract text from PDF or image.'/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default HowItWorks;